// Static imports: eight small JSON bundles, no lazy backend (and no extra CSP).

import en_common from './locales/en/common.json'
import en_errors from './locales/en/errors.json'
import en_map from './locales/en/map.json'
import es_common from './locales/es/common.json'
import es_errors from './locales/es/errors.json'
import es_map from './locales/es/map.json'
import ptPT_common from './locales/pt-PT/common.json'
import ptPT_errors from './locales/pt-PT/errors.json'
import ptPT_map from './locales/pt-PT/map.json'
import ptBR_common from './locales/pt-BR/common.json'
import ptBR_errors from './locales/pt-BR/errors.json'
import ptBR_map from './locales/pt-BR/map.json'
import fr_common from './locales/fr/common.json'
import fr_errors from './locales/fr/errors.json'
import fr_map from './locales/fr/map.json'
import de_common from './locales/de/common.json'
import de_errors from './locales/de/errors.json'
import de_map from './locales/de/map.json'
import it_common from './locales/it/common.json'
import it_errors from './locales/it/errors.json'
import it_map from './locales/it/map.json'
import nl_common from './locales/nl/common.json'
import nl_errors from './locales/nl/errors.json'
import nl_map from './locales/nl/map.json'

export const resources = {
  en: { common: en_common, errors: en_errors, map: en_map },
  es: { common: es_common, errors: es_errors, map: es_map },
  'pt-PT': { common: ptPT_common, errors: ptPT_errors, map: ptPT_map },
  'pt-BR': { common: ptBR_common, errors: ptBR_errors, map: ptBR_map },
  fr: { common: fr_common, errors: fr_errors, map: fr_map },
  de: { common: de_common, errors: de_errors, map: de_map },
  it: { common: it_common, errors: it_errors, map: it_map },
  nl: { common: nl_common, errors: nl_errors, map: nl_map },
} as const
